export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/ca-es.lyaml"));
at({ "ca-es": { "public": { "sampleString": "Cadena d'exemple" } } });
};